import React from 'react';

export default function DiscoveryTextSection() {
  return (
    <section className="py-14">
      <div className="max-w-7xl xl:max-w-[1600px] 2xl:max-w-[1800px] mx-auto px-6 lg:px-8">
        <div className="bg-card/40 backdrop-blur-sm border border-border rounded-2xl p-8 md:p-10">
          <div className="max-w-4xl mx-auto space-y-10">
            <div className="space-y-3">
              <h2 className="text-2xl sm:text-3xl font-bold text-foreground">What is Neevii?</h2>
              <p className="text-muted-foreground">
                Neevii is an AI-powered accounting, bookkeeping, and invoicing app for UK small businesses, freelancers, sole traders, and limited companies.
                It helps track income and expenses, manage invoices, and prepare HMRC-ready workflows like Self Assessment (SA100), VAT returns (including MTD VAT), and Corporation Tax (CT600) in one place.
              </p>
              <p className="text-muted-foreground">
                Neevii is HMRC Recognised for Making Tax Digital (MTD) ITSA and MTD VAT.
              </p>
              <p className="text-muted-foreground">
                Available on the web and Android via Google Play:{' '}
                <a
                  className="underline hover:text-foreground transition-colors"
                  href="https://play.google.com/store/apps/details?id=com.neevii.app"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Neevii - Smart Accounting
                </a>
                .
              </p>
              <p className="text-muted-foreground">
                Neevii is designed for smaller businesses that want clarity and automation without the complexity of enterprise accounting tools.
              </p>
            </div>

            <div className="space-y-3">
              <h2 className="text-2xl sm:text-3xl font-bold text-foreground">What Neevii Helps With</h2>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
                <li>Track income and expenses automatically</li>
                <li>Categorise transactions using AI assistance</li>
                <li>Create and send professional invoices</li>
                <li>Prepare HMRC-ready workflows like Self Assessment (SA100), VAT returns (MTD VAT), and Corporation Tax (CT600)</li>
                <li>Support both sole traders and limited companies</li>
                <li>Designed for UK small businesses and side incomes</li>
              </ul>
            </div>

            <div className="space-y-3">
              <h2 className="text-2xl sm:text-3xl font-bold text-foreground">Founder-led help when you’re stuck</h2>
              <p className="text-muted-foreground">
                If you’re stuck with VAT, Self Assessment, or bookkeeping and don’t know what to do next, I offer founder-led support to help you get unstuck — with Neevii.
              </p>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
                <li>UK sole traders &amp; limited companies</li>
                <li>VAT return, SA100, CT600 guidance</li>
                <li>Calm, practical help — no jargon</li>
              </ul>
              <p className="text-muted-foreground">
                <a
                  className="underline hover:text-foreground transition-colors"
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@neevii.com&su=Neevii%20enquiry"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Get founder help (Gmail)
                </a>
              </p>
              <p className="text-muted-foreground text-sm">
                Built by a UK freelancer — not a VC-backed accounting platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

